// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import VueI18n from 'vue-i18n';

/* 路由 */
import router from './router'


/* swiper */
import 'swiper/dist/css/swiper.min.css'

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name, Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name, Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name, GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})



Vue.use(ElementUI,VueI18n)
window.Vue = Vue

const i18n = new VueI18n({
  locale: localStorage.getItem('languageSet')||'zh',
  messages: {
    'zh': require('./utils/language/zh'),   // 通过require引入中文语言包
    'en': require('./utils/language/en'),    // 通过require引入英文语言包
  }
})


new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  beforeCreate(){                 //在初始化阶段前
		Vue.prototype.$bus = this   //配置全局总线，bus有总线的意思
	},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js